import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './SideNav.css';
import home1 from '../images/home1.png';
import home2 from '../images/home2.png';
import search1 from '../images/search1.png';
import search2 from '../images/search2.png';
import chat1 from '../images/chat1.png';
import chat2 from '../images/chat2.png';
import notification1 from '../images/notification1.png';
import notification2 from '../images/notification2.png';
import slots1 from '../images/slots1.png';
import slots2 from '../images/slots2.png';
import bookings1 from '../images/booking1.png';
import bookings2 from '../images/booking2.png';
import earnings1 from '../images/earning1.png';
import earnings2 from '../images/earning2.png';
import account1 from '../images/user1.png';
import account2 from '../images/user2.png';
import myprofile1 from '../images/account1.png';
import myprofile2 from '../images/account2.png';
import { useNavigate } from 'react-router-dom';
import { BsGearFill } from 'react-icons/bs';
import { toast } from 'react-hot-toast';
import { getNotifications } from '../../api/getNotifications';
import { userChats } from '../../api/chatRequest';
import { getMessages } from '../../api/messageRequest';

const SideNav = ({ setProgress, Mentor, isAdmin, isSocietyMember, isFetched}) => {
  const navigate = useNavigate();
  const [showChatNotification, setShowChatNotification] = useState(false);

  const logout = async () => {
    try {
      setProgress(30);
      localStorage.removeItem('skilloptoken');
      localStorage.removeItem('tokenExpiry');
      
    } catch (error) {
      toast.error(error)
    }
    toast.success('Logged out');
    navigate('/login');
    setProgress(100);
  };

  const handleSlots = () => {
    if (isFetched) {
      setProgress(40);
      if (Mentor) {
        navigate('/mySlots');
      } else {
        navigate('/homepage');
        toast.error('Slots page is 🔒 locked\nBecome a MENTOR 😎 to unlock!');
      }
      setTimeout(() => setProgress(100), 300);
    }
  };

  const handleBookings = () => {
    if (isFetched) {
      setProgress(40);
      if (Mentor) {
        navigate('/book');  // cahnge back to mybookings in future
      } else {
        navigate('/homepage');
        toast.error('Booking page is 🔒 locked\nBecome a MENTOR 😎 to unlock!');
      }
      setTimeout(() => setProgress(100), 300);
    }
  };

  const handleEarnings = () => {

    if (isFetched) {
      setProgress(40);
      if (Mentor) {
        navigate('/myearnings');
      } else {
        navigate('/homepage');
        toast.error('Earning page is 🔒 locked\nBecome a MENTOR 😎 to unlock!');
      }
     
    }
  };

  const [showExtra, setShowExtra] = useState(false);
  const [extraPos, setExtraPos] = useState({ bottom: 0, left: 0 });
  const settingsRef = useRef(null);
  const closeTimerRef = useRef(null);

  const openExtra = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    if (settingsRef.current) {
      const rect = settingsRef.current.getBoundingClientRect();
      setExtraPos({
        bottom: window.innerHeight - rect.bottom,
        left: rect.right + 4,
      });
    }
    setShowExtra(true);
  };

  const scheduleCloseExtra = () => {
    closeTimerRef.current = setTimeout(() => setShowExtra(false), 250);
  };

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    };
  }, []);

  const [notifyList, setNotifyList] = useState([]);

  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem('theme') === 'dark'
  );

  useEffect(() => {
    document.body.classList.toggle('dark-theme', darkMode);
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const fetchNotifications = async () => {
    try {
      const NotiData = await getNotifications();
      setNotifyList(NotiData.data.result);
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  const checkChatNotification = async () => {
    try {
      const CurrUsrId = localStorage.getItem('current-user-id');
      const { data } = await userChats(CurrUsrId);
      data.forEach(async (chat) => {
        const data2 = await getMessages(chat._id);
        data2.data.forEach((msg) => {
          if (!msg.seen && msg.senderId !== CurrUsrId) {
            setShowChatNotification(true);
            return;
          }
        });
      });
    } catch (err) {}
  };

  useEffect(() => {
    fetchNotifications();
    checkChatNotification();
  }, []);

  return (
    <>
      <ul className='side-nav-container'>
        <li
          onClick={() => {
            setProgress(40);
            navigate('/homepage');
            setTimeout(() => setProgress(100), 300);
          }}
        >
          {window.location.pathname === '/homepage' ? (
            <img src={home2} alt='Home' />
          ) : (
            <img src={home1} alt='Home'  />
          )}
          <span
            className={`${
              window.location.pathname === '/homepage' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Home
          </span>
        </li>
        <li
          onClick={() => {
            setProgress(40);
            navigate('/searchbar');
            setTimeout(() => setProgress(100), 300);
          }}
        >
          {window.location.pathname === '/searchbar' ? (
            <img src={search2} alt='Home'   />
          ) : (
            <img src={search1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/searchbar' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Search
          </span>
        </li>
        <li
          onClick={() => {
            setProgress(40);
            navigate('/chat');
            setTimeout(() => setProgress(100), 300);
          }}
        >
          {window.location.pathname === '/chat' ? (
            <img src={chat2} alt='Home'   />
          ) : (
            <img src={chat1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/chat' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Chat
          </span>
          {showChatNotification && (
            <div>
              <div className='chat-notify-num-icon'>*</div>{' '}
            </div>
          )}
        </li>
        <li
          onClick={() => {
            setProgress(40);
            navigate('/notifications');
            setTimeout(() => setProgress(100), 300);
          }}
        >
          {window.location.pathname === '/notifications' ? (
            <img src={notification2} alt='Home'/>
          ) : (
            <img src={notification1} alt='Home'/>
          )}
          <span
            className={`${
              window.location.pathname === '/notifications' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Notifications
          </span>
          {notifyList.filter((item) => item.read === false).length > 0 && (
            <div>
              <div className='notify-num-icon'>
                {notifyList.filter((item) => item.read === false).length}
              </div>{' '}
            </div>
          )}
        </li>
        <li
          onClick={() => {
            setProgress(40);
            navigate('/requestedMeets');
            setTimeout(() => setProgress(100), 300);
          }}
        >
          {window.location.pathname === '/requestedMeets' ? (
            <img src='/meet2.png' alt='Home'   />
          ) : (
            <img src='/meet.png' alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/requestedMeets' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Meets
          </span>
        </li>
        <li onClick={handleSlots}>
          {window.location.pathname === '/mySlots' ? (
            <img src={slots2} alt='Home'   />
          ) : (
            <img src={slots1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/mySlots' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Slots
          </span>
          {!Mentor && <img id='notify-lock' src='/lock1.png' alt='lock' />}
        </li>
        <li onClick={handleBookings}>
          {window.location.pathname === '/mybookings' ? (
            <img src={bookings2} alt='Home'   />
          ) : (
            <img src={bookings1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/mybookings' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Booking
          </span>
          {!Mentor && <img id='notify-lock' src='/lock1.png' alt='lock' />}
        </li>
        <li onClick={handleEarnings}>
          {window.location.pathname === '/myearnings' ? (
            <img src={earnings2} alt='Home'   />
          ) : (
            <img src={earnings1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/myearnings' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Earning
          </span>
          {!Mentor && <img id='notify-lock' src='/lock1.png' alt='lock' />}
        </li>
        <li
          onClick={() => {
            setProgress(40);
            navigate('/myaccount');
            setTimeout(() => setProgress(100), 300);
          }}
        >
          {window.location.pathname === '/myaccount' ? (
            <img src={myprofile2} alt='Home'   />
          ) : (
            <img src={myprofile1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/myaccount' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Account
          </span>
        </li>
        <li
          onClick={() => {
            setProgress(40);
            navigate('/Profile');
            setTimeout(() => setProgress(100), 300);
          }}
        >
          {window.location.pathname === '/Profile' ? (
            <img src={account2} alt='Home'   />
          ) : (
            <img src={account1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/Profile' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            My profile
          </span>
        </li>
        <li
          id='setting'
          className='settings-opt'
          ref={settingsRef}
          onMouseEnter={openExtra}
          onMouseLeave={scheduleCloseExtra}
        >
          <BsGearFill style={{ fontSize: '27px', marginRight: '13px' }} />
          <span className={`hover-effect-bottom`}>Settings</span>
          {showExtra &&
            createPortal(
              <div
                className='xtra-opt'
                style={{ bottom: extraPos.bottom, left: extraPos.left }}
                onMouseEnter={openExtra}
                onMouseLeave={scheduleCloseExtra}
              >
                {!Mentor && (
                  <div
                    className='xtra-opt-item'
                    style={{ color: '#108CFF' }}
                    onClick={() => navigate('/mentorBano')}
                  >
                    <img src='/verified.png' alt=''/>
                    Become Mentor
                  </div>
                )}
                {isAdmin && (
                  <div
                    className='xtra-opt-item'
                    style={{ color: '#108CFF' }}
                    onClick={() => navigate('/Admin_Dashboard')}
                  >
                    <img src='/verified.png' alt=''/>
                    Admin Panel
                  </div>
                )}
                {isSocietyMember && (
                  <div
                    className='xtra-opt-item'
                    style={{ color: '#108CFF' }}
                    onClick={() => navigate('/dashboard')}
                  >
                    <img src='/verified.png' alt=''/>
                    Skillop Dashboard
                  </div>
                )}
                <div
                  className='xtra-opt-item'
                  style={{ color: '#108CFF' }}
                  onClick={() => navigate('/platformfeedback')}
                >
                  <img src='/feedback.png' alt=''/>
                  FeedBack
                </div>
                <div
                  className='xtra-opt-item dark-mode-toggle-row'
                  style={{ color: '#fff' }}
                  onClick={() => setDarkMode((prev) => !prev)}
                >
                  <span
                    className={`dark-mode-toggle ${darkMode ? 'on' : ''}`}
                  >
                    <span className='dark-mode-toggle-knob' />
                  </span>
                  Dark Mode
                </div>
                <div
                  className='xtra-opt-item'
                  style={{ color: '#FF4141' }}
                  onClick={logout}
                >
                  <img src='/logout.png' width={30} alt=''/>
                  Logout
                </div>
              </div>,
              document.body
            )}
        </li>
      </ul>
    </>
  );
};

export default SideNav;
